import React, {useEffect, useState} from "react";
import axiosConfig from "../utils/axiosConfig";
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import Paper from "@mui/material/Paper"
import Typography from "@mui/material/Typography";
import {useNavigate} from "react-router-dom"
import appConfig from "../utils/Config";

const UserManuals = () => {
  const [manuals, setManuals] = useState([]);
  const navigate = useNavigate()
  const url = appConfig.drupal.host


  useEffect(() => {
    const fetchManuals = async () => {
      const axios = await axiosConfig();

      try {
        const response = await axios.get(`${url}/api/manuals`, {
          params: {
            manualType: 213
          }
        })
        if (response.data) {
          setManuals(response.data.results)
        }
      }catch (e) {
        console.log(e.text)
      }


    }
    fetchManuals()
  }, [url]);


  function toManualDetails(manualId, title) {
    navigate(`/manual/${manualId}`, {state:{manualId:manualId, title:title}})
  }

  return(
    <div className="manuals">
      <header>
        <Typography component={"h3"}>
          User Manuals
        </Typography>
      </header>
      {
        manuals.length > 0 ? (
          <TableContainer component={Paper}>
            <Table   sx={{ minWidth: 650 }} aria-label="simple table" >
              <TableHead>
                <TableRow>
                  <TableCell component="th" scope="row">Title</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  manuals.map((row) => (
                    <TableRow
                      key={row.manual_id}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 }, '&:hover': {cursor: 'pointer'} }}
                      onClick={() => toManualDetails(row.manual_id, row.title)}
                    >
                      <TableCell>
                        {row.title}
                      </TableCell>
                    </TableRow>
                  ))
                }
              </TableBody>
            </Table>

          </TableContainer>
        ) : (
          <Typography>
            {(
              'manuals.NoResultsFound',
              'No Results Found'
            )}
          </Typography>
        )
      }
    </div>
  )

}

export default UserManuals

